import { queryClient, ToastRef } from '@frontend/shared';
import { Seo, Toast } from '@frontend/shared/web';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { Router } from './services/routing/Router';

export const App = () => (
  <StrictMode>
    <HelmetProvider>
      <Seo title="Portail extranet" />
      <QueryClientProvider client={queryClient}>
        <div className="min-h-viewport bg-extranet-bg text-extranet-text-primary">
          <Router />
          <Toast ref={ToastRef} />
          <ReactQueryDevtools initialIsOpen={false} />
        </div>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>
);
